import { render, staticRenderFns } from "./email.vue?vue&type=template&id=411974b6&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=411974b6&prod&lang=scss&scoped=true"
import style1 from "./email.vue?vue&type=style&index=1&id=411974b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411974b6",
  null
  
)

export default component.exports